import { render, staticRenderFns } from "./MarketChart.vue?vue&type=template&id=de15c418&scoped=true&"
import script from "./MarketChart.vue?vue&type=script&lang=js&"
export * from "./MarketChart.vue?vue&type=script&lang=js&"
import style0 from "./MarketChart.vue?vue&type=style&index=0&id=de15c418&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de15c418",
  null
  
)

export default component.exports